import React from 'react';

export default function Floating() {
  return (
    <div className="floating-availability">Available this week</div>
  );
}
